export default __webpack_public_path__ + "static/media/Phial of Heavenly Knowledge.ed47b283.jpg";